<template>
  <div @click="receiveReward" v-show="popupVisible" style="position: fixed; left: 0;top: 0;z-index: 100;width: 100%;height: 100%;background: transparent;">
    <div style="width: 1.5rem;height: 1.5rem;background: rgba(0,0,0,0.6);border-radius: 0.1rem;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)">
      <p style="color: #fcc002;font-size: .16rem;text-align: center;line-height: 0.5rem;font-weight: bold;">{{title||'任务完成'}}</p>
      <div style="display: flex;align-items: center;justify-content: center;margin: 0.05rem 0;">
        <img v-if="type=='REDPACKET'" src="../../assets/image/hb.png"
             style="height: 0.4rem;margin-right: 0.1rem"/>
        <img v-else-if="type=='INTEGRATION'" src="../../assets/image/jifen.png"
             style="height: 0.4rem;margin-right: 0.1rem"/>
        <img v-else-if="type=='YUAN'" src="../../assets/image/yuan.png"
             style="height: 0.4rem;margin-right: 0.1rem"/>
        <img v-else-if="type=='ACTIVE'" src="../../assets/image/liwu_icon.png"
             style="height: 0.4rem;margin-right: 0.1rem"/>
        <span style="color: #ffde02;font-size: .16rem;">{{condition}}</span>
      </div>
      <p style="color: #fff;font-size: .14rem;text-align: center;line-height: 0.5rem">点击任意处领取</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "receive-reward",
    props: ['showCB','closeCB'],
    data(){
      return {
        popupVisible: false,
        list: [],
        //标题类型 ：SIGN 签到 MISSION 任务
        //奖励类型 ：REDPACKET 红包 INTEGRATION 积分 YUAN 元 ACTIVE 活跃度
        //奖励:+1
        title: '签到',
        type: 'REDPACKET',
        condition: '+1',
      }
    },
    methods:{
      show(){
        var data = this.list[0];
        if(data.title=='SIGN'){
          this.title = '登录签到';
        }else if(data.title=='MISSION'){
          this.title = '任务完成';
        }else{
          this.title = data.title;
        }
        this.type = data.type;
        this.condition = data.condition;
        this.popupVisible = true;
        if(typeof this.showCB == 'function'){
          this.showCB();
        }
      },
      receiveReward(){
        this.list.shift();
        this.popupVisible = false;
        if(typeof this.closeCB == 'function'){
          this.closeCB();
        }
        if(this.list.length>0){
          setTimeout(()=>{
            this.show();
          },300);
        }
      },
      add(data){
        this.list.push(data);
        if(this.list.length==1){
          this.show();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/receive-reward.vue